import { cn as e } from "../lib/utils.js";
import * as t from "react";
import { jsx as n } from "react/jsx-runtime";
import * as r from "@radix-ui/react-separator";
//#region src/shadcn/separator.tsx
var i = t.forwardRef(({ className: t, orientation: i = "horizontal", decorative: a = !0, ...o }, s) => /* @__PURE__ */ n(r.Root, {
	ref: s,
	decorative: a,
	orientation: i,
	className: e("shrink-0 bg-border", i === "horizontal" ? "h-[1px] w-full" : "h-full w-[1px]", t),
	...o
}));
i.displayName = r.Root.displayName;
//#endregion
export { i as Separator };
